import { render, staticRenderFns } from "./FormDrugs.vue?vue&type=template&id=0d470448&scoped=true"
import script from "./FormDrugs.vue?vue&type=script&lang=js"
export * from "./FormDrugs.vue?vue&type=script&lang=js"
import style0 from "./FormDrugs.vue?vue&type=style&index=0&id=0d470448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d470448",
  null
  
)

export default component.exports